window.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.cars__visible-container');
  const downBtn = document.querySelector('.scroll-btn.down');

  // Якщо елементів немає на сторінці — нічого не робимо
  if (!container || !downBtn) return;

  const cardHeight = (192 + 16) * 2;

  // уникаємо подвійної ініціалізації
  if (!downBtn.dataset.listenerAttached) {
    downBtn.addEventListener('click', () => {
      container.scrollBy({ top: cardHeight, behavior: 'smooth' });
    });
    downBtn.dataset.listenerAttached = 'true';
  }
});
